export default "__VITE_ASSET__Bx8gK0e6__"